// extracted by mini-css-extract-plugin
export default {"base-hero":"BaseHero_base-hero__wcJyW","base-hero__content":"BaseHero_base-hero__content__vAgml","base-hero__body":"BaseHero_base-hero__body__uxJ80"};